import './InsightsAgent.scss';
import { MdOutlineAutoAwesome } from 'react-icons/md';
import { AgentSessionManager } from '@Components/AgentChat';
import { Page } from '@Components/Page';
import { useAppSelector } from '../../redux';
import * as UserRedux from '../../redux/user';
import { Agent, useAgentEndpoint } from '../../utils/agent-endpoints';
import { useCompanyInfo } from '../../utils/hooks/useCompanyInfo';

export const InsightsAgent = () => {
  const agentEndpoint = useAgentEndpoint(Agent.INSIGHTS);
  const { cid: company } = useCompanyInfo();
  return (
    <Page title='Insights Agent' pageType='Insights Agent'>
      <AgentSessionManager
        agentEndpoint={agentEndpoint}
        agent={Agent.INSIGHTS}
        company={company}
        emptyState={<NewChatEmptyState />}
        className='insights-agent'
      />
    </Page>
  );
};

const NewChatEmptyState = () => {
  const fullName = useAppSelector(UserRedux.fullNameSelector);
  const firstName = fullName?.split(/\s+/)[0] ?? '';

  return (
    <div className='new-chat'>
      <div className='new-chat-header'>
        <div className='new-chat-icon'>
          <MdOutlineAutoAwesome />
        </div>
        {firstName && <h1 className='greeting'>Hey, {firstName}!</h1>}
        <h1 className='cta'>Let&apos;s get some insights!</h1>
      </div>
    </div>
  );
};
